import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/inventoryDeficiencyReport'
import Component from 'components/Reports/InventoryDeficiencyReport'

export default createListViewContainer({ actions, selectors: selectors.inventoryDeficiencyReport })(Component)
